export const FETCH_TENANTS_LIST = 'FETCH_TENANTS_LIST';
export const GET_SINGLE_TENANT = 'GET_SINGLE_TENANT';
export const SET_TENANT_PARAMS = 'SET_TENANT_PARAMS';
export const CREATE_TENANT = 'CREATE_TENANT';
export const UPDATE_TENANT = 'UPDATE_TENANT';
export const FETCH_MINIFIED_TENANTS_LIST = 'FETCH_MINIFIED_TENANTS_LIST';
export const SET_TENANT_SET_IS_FETCHING = 'SET_TENANT_SET_IS_FETCHING';

export const CLEAR_TENANT_STORE = 'CLEAR_TENANT_STORE';
